/**
 * Function created to used as callback for sort function
 * Makes the item with same ID appear first
 */
export const sortTermById = (id: string, searchTerm?: string) =>
  id === searchTerm ? -1 : 0
